module.exports = __webpack_public_path__ + "static/img/p-26.bbc0639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-26.png
// module id = ASTS
// module chunks = 0